// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function () {
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function () {
	Breakpoint.refreshValue();
}).resize();


// Libs
import PubSub from "underpub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";

// Components Import -- DO NOT REMOVE COMMENT!
import Timeline from "../../templates/_components/molecules/Misc/Timeline/Timeline";
import Stats from "../../templates/_components/molecules/Listings/Stats/Stats";
import Awards from "../../templates/_components/molecules/Listings/Awards/Awards";
import Contact from "../../templates/_components/molecules/Misc/Contact/Contact";
import CareerListings from "../../templates/_components/molecules/Listings/CareerListings/CareerListings";
import DetailsTableTwoUp from "../../templates/_components/molecules/Content/DetailsTableTwoUp/DetailsTableTwoUp";
import LayoutProjectDetail from "../../templates/_components/layouts/LayoutProjectDetail/LayoutProjectDetail";
import MediaDuo from "../../templates/_components/molecules/Media/MediaDuo/MediaDuo";
import ProjectsThreeUp from "../../templates/_components/molecules/Listings/ProjectsThreeUp/ProjectsThreeUp";
import MediaPrimary from "../../templates/_components/molecules/Media/MediaPrimary/MediaPrimary";
import PortfolioListings from "../../templates/_components/molecules/Listings/PortfolioListings/PortfolioListings";
import Logos from "../../templates/_components/molecules/Listings/Logos/Logos";
import DetailsTable from "../../templates/_components/elements/Content/DetailsTable/DetailsTable";
import LayoutBasicContentSidebar from "../../templates/_components/layouts/LayoutBasicContentSidebar/LayoutBasicContentSidebar";
import TextContent from "../../templates/_components/molecules/Basic/TextContent/TextContent";
import Breadcrumbs from "../../templates/_components/elements/Global/Breadcrumbs/Breadcrumbs";
import NewsListings from "../../templates/_components/molecules/Listings/NewsListings/NewsListings";
import PeopleListings from "../../templates/_components/molecules/Listings/PeopleListings/PeopleListings";
import ContentTextMediaTypeTwo from "../../templates/_components/molecules/Content/ContentTextMediaTypeTwo/ContentTextMediaTypeTwo";
import DropdownInfoItem from "../../templates/_components/elements/Content/DropdownInfoItem/DropdownInfoItem";
import ContentDropdownInfoItems from "../../templates/_components/molecules/Content/ContentDropdownInfoItems/ContentDropdownInfoItems";
import ContentInfoItems from "../../templates/_components/molecules/Content/ContentInfoItems/ContentInfoItems";
import Carousel from "../../templates/_components/elements/Media/Carousel/Carousel";
import ContentTextMediaTypeOne from "../../templates/_components/molecules/Content/ContentTextMediaTypeOne/ContentTextMediaTypeOne";
import HeaderNavigationDropdown from "../../templates/_components/atoms/Global/HeaderNavigationDropdown/HeaderNavigationDropdown";
import CardProject from "../../templates/_components/elements/Cards/CardProject/CardProject";
import ProjectsSlider from "../../templates/_components/molecules/Listings/ProjectsSlider/ProjectsSlider";
import NewsFeatureCards from "../../templates/_components/molecules/Listings/NewsFeatureCards/NewsFeatureCards";
import CardFeature from "../../templates/_components/elements/Cards/CardFeature/CardFeature";
import FeatureCardsTwoUp from "../../templates/_components/molecules/Listings/FeatureCardsTwoUp/FeatureCardsTwoUp";
import Footer from "../../templates/_components/molecules/Global/Footer/Footer";
import Label from "../../templates/_components/atoms/Text/Label/Label";
import ContentText from "../../templates/_components/molecules/Content/ContentText/ContentText";
import Pagination from "../../templates/_components/elements/Global/Pagination/Pagination";
import Form from "../../templates/_components/elements/Forms/Form/Form";
import ButtonIcon from "../../templates/_components/atoms/Buttons/ButtonIcon/ButtonIcon";
import ButtonSecondary from "../../templates/_components/atoms/Buttons/ButtonSecondary/ButtonSecondary";
import Styleguide from "../../templates/_components/molecules/Misc/Styleguide/Styleguide";
import HeroBasic from "../../templates/_components/molecules/Heros/HeroBasic/HeroBasic";
import ButtonPrimary from "../../templates/_components/atoms/Buttons/ButtonPrimary/ButtonPrimary";
import Hamburger from "../../templates/_components/atoms/Global/Hamburger/Hamburger";
import ResponsiveImage from "../../templates/_components/atoms/Media/ResponsiveImage/ResponsiveImage";
import ModalNavigation from "../../templates/_components/molecules/Modals/ModalNavigation/ModalNavigation";
import HeaderNavigation from "../../templates/_components/elements/Global/HeaderNavigation/HeaderNavigation";
import Header from "../../templates/_components/molecules/Global/Header/Header";
import VideoLoop from "../../templates/_components/atoms/Media/VideoLoop/VideoLoop";
import MediaTakeover from "../../templates/_components/elements/Media/MediaTakeover/MediaTakeover";
import HeroStandard from "../../templates/_components/molecules/Heros/HeroStandard/HeroStandard";
import BreakpointIndicator from "../../templates/_components/atoms/Global/BreakpointIndicator/BreakpointIndicator";

$(document).ready(function () {

	var components = [
		// Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".mol-Timeline", require: Timeline },
{handle: ".mol-Stats", require: Stats },
{handle: ".mol-Awards", require: Awards },
{handle: ".mol-Contact", require: Contact },
{handle: ".mol-CareerListings", require: CareerListings },
{handle: ".mol-DetailsTableTwoUp", require: DetailsTableTwoUp },
{handle: ".layout-LayoutProjectDetail", require: LayoutProjectDetail },
{handle: ".mol-MediaDuo", require: MediaDuo },
{handle: ".mol-ProjectsThreeUp", require: ProjectsThreeUp },
{handle: ".mol-MediaPrimary", require: MediaPrimary },
{handle: ".mol-PortfolioListings", require: PortfolioListings },
{handle: ".mol-Logos", require: Logos },
{handle: ".el-DetailsTable", require: DetailsTable },
{handle: ".layout-LayoutBasicContentSidebar", require: LayoutBasicContentSidebar },
{handle: ".mol-TextContent", require: TextContent },
{handle: ".el-Breadcrumbs", require: Breadcrumbs },
{handle: ".mol-NewsListings", require: NewsListings },
{handle: ".mol-PeopleListings", require: PeopleListings },
{handle: ".mol-ContentTextMediaTypeTwo", require: ContentTextMediaTypeTwo },
{handle: ".el-DropdownInfoItem", require: DropdownInfoItem },
{handle: ".mol-ContentDropdownInfoItems", require: ContentDropdownInfoItems },
{handle: ".mol-ContentInfoItems", require: ContentInfoItems },
{handle: ".el-Carousel", require: Carousel },
{handle: ".mol-ContentTextMediaTypeOne", require: ContentTextMediaTypeOne },
{handle: ".atom-HeaderNavigationDropdown", require: HeaderNavigationDropdown },
{handle: ".el-CardProject", require: CardProject },
{handle: ".mol-ProjectsSlider", require: ProjectsSlider },
{handle: ".mol-NewsFeatureCards", require: NewsFeatureCards },
{handle: ".el-CardFeature", require: CardFeature },
{handle: ".mol-FeatureCardsTwoUp", require: FeatureCardsTwoUp },
{handle: ".mol-Footer", require: Footer },
{handle: ".atom-Label", require: Label },
{handle: ".mol-ContentText", require: ContentText },
{handle: ".el-Pagination", require: Pagination },
{handle: ".el-Form", require: Form },
{handle: ".atom-ButtonIcon", require: ButtonIcon },
{handle: ".atom-ButtonSecondary", require: ButtonSecondary },
{handle: ".mol-Styleguide", require: Styleguide },
{handle: ".mol-HeroBasic", require: HeroBasic },
{handle: ".atom-ButtonPrimary", require: ButtonPrimary },
{handle: ".atom-Hamburger", require: Hamburger },
{handle: ".atom-ResponsiveImage", require: ResponsiveImage },
{handle: ".mol-ModalNavigation", require: ModalNavigation },
{handle: ".el-HeaderNavigation", require: HeaderNavigation },
{handle: ".mol-Header", require: Header },
{handle: ".atom-VideoLoop", require: VideoLoop },
{handle: ".el-MediaTakeover", require: MediaTakeover },
{handle: ".mol-HeroStandard", require: HeroStandard },
{handle: ".atom-BreakpointIndicator", require: BreakpointIndicator },
	];

	var sitewide = new Sitewide();
	sitewide.init();

	// Getting our components loading going
	window.componentsLoader = new ComponentsLoader({
		components: components
	});
	window.componentsLoader.initScreen();

	// setting our breakpoint value
	Breakpoint.refreshValue();

});